import { getData } from './Services';

export const getTipoDocumentos = async () => {
  try {
    const res = await getData('/tiposdoc'); // sin `/id`
    return res || [];
  } catch (error) {
    console.error('Error al obtener tipos de documentos:', error);
    return [];
  }
};
